import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  isDownloading: false,
  totalCount: 0,
  reportTotal: [],
  entities: [],
  lastError: null,
  message: null,
  error: null,
  itemName:"",
  itemType:""
};
export const callTypes = {
  list: "list",
  action: "action",
  download: "download",
};

export const slice = createSlice({
  name: "inventoryTransactionReport",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    setItemName: (state, action) => {
      state.itemName = action.payload.itemName;
    },
    setItemType: (state, action) => {
      state.itemType = action.payload.itemType;
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.download) {
        state.isDownloading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.download) {
        state.isDownloading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getLocationById
    fetchById: (state, action) => {
      state.actionsLoading = false;
      state.locationForEdit = action.payload.locationForEdit;
      state.floorPlans = action.payload.locationForEdit.floorPlans;
      state.error = null;
    },
    // get list data
    fetchedAll: (state, action) => {
      const { totalCount, entities, reportTotal } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.reportTotal = reportTotal;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    downloadFile: (state, action) => {
      state.isDownloading = false;
      state.message = {
        status: "success",
        message: "The file will be downloaded soon..",
      };
    },
  },
});
